var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"newbigbox"},[_c('el-row',{staticClass:"newMain"},[_c('img',{attrs:{"src":require("@/assets/image/news/wherewevebeen.png"),"alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }